import MatomoTrackEventCc from './matomo-track-event-cc';

export default class MatomoEventsCc {
    constructor() {
        if (typeof window._paq !== 'undefined' && window._paq !== null && window.location.href.includes('/kreditkarte')) this.init();
    }

    init() {
        this.trackTeaserFormSubmit();
    }

    trackTeaserFormSubmit() {
        const teaserForm = document.querySelector('.teaser-form');
        // eslint-disable-next-line no-unused-expressions
        teaserForm?.addEventListener('submit', (e) => {
            const value = {};
            Object.values(e.target).forEach((item) => {
                if (item.name === 'withOnboarding' && item.checked) {
                    value[item.name] = item.value;
                }
            });

            const matomoEventTracker = new MatomoTrackEventCc();
            matomoEventTracker
                .setCategory('startPage')
                .setAction({
                    event: 'submit',
                    area: 'teaser',
                    element: 'form',
                    modifier: 'userInput'
                })
                .setName(value)
                .pushEvent();
        });
    }
}
